import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PslfFormVersionSchema = withDefaults({
  type: 'pslf-form-version',
  traits: ['version'],
  fields: [],
});

export default PslfFormVersionSchema;
